/* eslint-disable no-nested-ternary */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/require-default-props */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/forbid-prop-types */
import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Controller, useForm } from 'react-hook-form';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { InformationCircleIcon } from '@heroicons/react/20/solid';
import { realEstateAccount } from '@monestry-dev/schema';
import { getAuthenticatedUser } from '../../../amplify/authUtilities';
import ToolTip from '../../../elements/ToolTip';
import { currencyCodes } from '../../../misc/currencyCodes';
import { countryCodes, getCountryName } from '../../../misc/countries';
import Dropdown from './Dropdown'; // import wrapper for the common Dropdown component
import InputField from '../../../elements/InputField';
import SwitchComponent from './SwitchComponent';
import LocationCombobox from './LocationCombobox';
import { getEstimataCities } from '../../../redux/actions/misc';

dayjs.extend(utc);

export function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

// expects an array of accounts which have a nextValuationDate as well as an array of all valuationSlots from Cognito
// returns next available valuation date (can be today if it is unused), after considering the accounts which already have a nextValuationDate
export function getNextAvailableValuationDate(accountsWithValuationSlots, valuationSlots) {
  // what is the next available valuation date? it is the date from valuationSlots which is not used in accountsWithValuationSlots.tags.nextValuationSlot
  // for each accountsWithValuationSlots.tags.nextValuationDate remove ONE corresponding item from valuationSlots
  const assignedSlots = accountsWithValuationSlots.map((x) => x.tags?.nextValuationDate).filter((x) => !!x); // remove undefined from the array (accounts with no nextValuationDate)

  const availableSlots = [...valuationSlots];

  assignedSlots.forEach((assignedSlot) => {
    const toBeRemoved = availableSlots.indexOf(assignedSlot);
    availableSlots.splice(toBeRemoved, 1);
  });

  const availableSlotsWithNoNull = availableSlots.map((x) => x || dayjs.utc().startOf('day').valueOf());

  // sort the array by date ascending and get the first element
  const nextValuationDate = availableSlotsWithNoNull.sort((a, b) => a - b)[0];
  return nextValuationDate;
}

function RealEstateAccountData({ index, updateWorkflowStatus, userInput, setUserInput, signalNext, setSignalNext, messageToShowBeforeNext, setMessageToShowBeforeNext }) {
  // register the hook
  const { register, watch, reset, getValues, control, formState, setValue, trigger } = useForm({ mode: 'onChange', defaultValues: userInput && userInput.data });
  const { errors, isValid, isDirty } = formState;

  const [displayUpdateValueSwitch, setDisplayUpdateValueSwitch] = useState(false);
  const [valuationSlots, setValuationSlots] = useState([]);
  const [subtypeList, setSubtypeList] = useState([{ id: null, name: null }]);

  const dispatch = useDispatch();
  const { t } = useTranslation('addAccount');
  const { t: tp } = useTranslation('app', { keyPrefix: 'schema.realEstate.account.valuationParameters' });

  const accounts = useSelector((state) => state.data.realEstate.accounts);
  const accountsWithValuationSlots = accounts.filter((x) => x.tags.nextValuationDate);
  const estimataCities = useSelector((state) => state.misc.estimataCities);
  const estimataCitiesStatus = useSelector((state) => state.misc.estimataCitiesStatus);

  const countryCodeValue = watch('valuationParameters.countryCode');

  // get city dictionary from estimata get_plzen if there aren't any in redux
  useEffect(() => {
    if (!estimataCities && estimataCitiesStatus === 'idle') {
      dispatch(getEstimataCities());
    }
  }, [dispatch, estimataCities, estimataCitiesStatus]);

  const normalizedEstimataCities = useMemo(() => {
    if (!estimataCities) return null;

    const toArray = (value) => {
      if (!value) return [];
      if (Array.isArray(value)) return value;
      if (typeof value === 'object') return Object.values(value);
      return [];
    };

    const normalizeStringList = (collection) => {
      const seen = new Set();
      const output = [];
      toArray(collection).forEach((item) => {
        const normalized = item == null ? '' : String(item);
        if (normalized && !seen.has(normalized)) {
          seen.add(normalized);
          output.push(normalized);
        }
      });
      return output;
    };

    const normalizeEntries = (collection) => {
      if (!collection) return [];
      return toArray(collection)
        .map((entry) => {
          if (Array.isArray(entry)) return entry;
          if (entry && typeof entry === 'object') {
            const { city, district, zip, name } = entry;
            return [city, district, zip, name];
          }
          return [];
        })
        .filter((entry) => Array.isArray(entry) && entry.length >= 3 && entry.some((value) => value !== undefined && value !== null && value !== ''))
        .map((entry) => {
          const [city, district, zip, ...rest] = entry;
          return [city == null ? '' : String(city), district == null ? '' : String(district), zip == null ? '' : String(zip), ...rest];
        });
    };

    const normalizedAllFromObject = normalizeEntries(toArray(estimataCities.all));
    const normalizedAllFromArray = Array.isArray(estimataCities) ? normalizeEntries(estimataCities) : [];
    const normalizedAll = normalizedAllFromObject.length ? normalizedAllFromObject : normalizedAllFromArray;

    const zipList = normalizeStringList(estimataCities.zip ?? estimataCities.plz ?? estimataCities.postcode ?? (normalizedAll.length ? normalizedAll.map((entry) => entry[2]) : []));
    const cityList = normalizeStringList(estimataCities.city ?? estimataCities.kreis ?? estimataCities.stadt ?? (normalizedAll.length ? normalizedAll.map((entry) => entry[0]) : []));
    const districtList = normalizeStringList(estimataCities.district ?? estimataCities.ort ?? estimataCities.districts ?? (normalizedAll.length ? normalizedAll.map((entry) => entry[1]) : []));

    if (!normalizedAll.length && !zipList.length && !cityList.length && !districtList.length) {
      return null;
    }

    return {
      zip: zipList,
      city: cityList,
      district: districtList,
      all: normalizedAll,
    };
  }, [estimataCities]);

  const isCountrySelected = Boolean(countryCodeValue);
  const isCountryGermany = countryCodeValue === 'DE';
  const hasLocationData = Boolean(normalizedEstimataCities);
  const shouldUseLocationCombobox = isCountryGermany && estimataCitiesStatus !== 'failed';
  const locationComboboxEnabled = shouldUseLocationCombobox && hasLocationData;

  const selectedZip = watch('valuationParameters.zip');
  const selectedCity = watch('valuationParameters.city');
  const selectedDistrict = watch('valuationParameters.district');

  const locationComboboxOptions = useMemo(() => {
    if (!locationComboboxEnabled || !normalizedEstimataCities) {
      return { zip: [], city: [], district: [] };
    }

    const baseZipOptions = Array.isArray(normalizedEstimataCities?.zip) ? normalizedEstimataCities.zip : [];
    const baseCityOptions = Array.isArray(normalizedEstimataCities?.city) ? normalizedEstimataCities.city : [];
    const baseDistrictOptions = Array.isArray(normalizedEstimataCities?.district) ? normalizedEstimataCities.district : [];
    const allEntries = Array.isArray(normalizedEstimataCities?.all) ? normalizedEstimataCities.all : [];

    if (!allEntries.length) {
      return {
        zip: baseZipOptions,
        city: baseCityOptions,
        district: baseDistrictOptions,
      };
    }

    const validZip = baseZipOptions.includes(selectedZip) ? selectedZip : undefined;
    const validCity = baseCityOptions.includes(selectedCity) ? selectedCity : undefined;
    const validDistrict = baseDistrictOptions.includes(selectedDistrict) ? selectedDistrict : undefined;

    const uniqueFromEntries = (entries, idx) => {
      const unique = new Set();
      entries.forEach((entry) => {
        const value = entry[idx];
        if (value !== undefined && value !== null && value !== '') {
          unique.add(String(value));
        }
      });
      return [...unique];
    };

    const zipEntries = allEntries.filter(([entryCity, entryDistrict]) => {
      if (validCity && entryCity !== validCity) return false;
      if (validDistrict && entryDistrict !== validDistrict) return false;
      return true;
    });

    const cityEntries = allEntries.filter(([, entryDistrict, entryZip]) => {
      if (validDistrict && entryDistrict !== validDistrict) return false;
      if (validZip && entryZip !== validZip) return false;
      return true;
    });

    const districtEntries = allEntries.filter(([entryCity, entryDistrict, entryZip]) => {
      if (validCity && entryCity !== validCity) return false;
      if (validZip && entryZip !== validZip) return false;
      return true;
    });

    const zipOptions = validCity || validDistrict ? uniqueFromEntries(zipEntries, 2) : baseZipOptions;
    const cityOptions = validZip || validDistrict ? uniqueFromEntries(cityEntries, 0) : baseCityOptions;
    const districtOptions = validCity || validZip ? uniqueFromEntries(districtEntries, 1) : baseDistrictOptions;

    return {
      zip: zipOptions,
      city: cityOptions,
      district: districtOptions,
    };
  }, [locationComboboxEnabled, normalizedEstimataCities, selectedZip, selectedCity, selectedDistrict]);

  useEffect(() => {
    if (!locationComboboxEnabled) return;

    if (selectedZip && locationComboboxOptions.zip.length > 0 && !locationComboboxOptions.zip.includes(selectedZip)) {
      setValue('valuationParameters.zip', '', { shouldDirty: true, shouldValidate: true });
    }
    if (selectedCity && locationComboboxOptions.city.length > 0 && !locationComboboxOptions.city.includes(selectedCity)) {
      setValue('valuationParameters.city', '', { shouldDirty: true, shouldValidate: true });
    }
    if (selectedDistrict && locationComboboxOptions.district.length > 0 && !locationComboboxOptions.district.includes(selectedDistrict)) {
      setValue('valuationParameters.district', '', { shouldDirty: true, shouldValidate: true });
    }
  }, [locationComboboxEnabled, locationComboboxOptions, selectedZip, selectedCity, selectedDistrict, setValue]);

  // get a list of valuationParamteres fields from schema that we want to display
  const valuationParametersSchemaObject = realEstateAccount.fields.valuationParameters.fields;
  // ↑↑ object of { field1: { type: 'string', _whitelist: ... }, field2: { type: 'number', _whitelist: ... }, ... }
  // _whitelist contains the oneOf members; its a ReferenceSet class instance; size property is the number of members
  const valuationParameters = Object.keys(valuationParametersSchemaObject);
  const prioritizedOrder = ['countryCode', 'zip', 'city', 'district', 'streetAddress', 'type', 'subtype', 'livingArea', 'completeArea'];
  const prioritizedParameters = prioritizedOrder.filter((param) => valuationParameters.includes(param));
  const remainingParameters = valuationParameters.filter((param) => !prioritizedParameters.includes(param));
  const sortedRemainingParameters = [...remainingParameters].sort((a, b) => {
    if (valuationParametersSchemaObject[a].spec.optional === valuationParametersSchemaObject[b].spec.optional) return 0;
    if (valuationParametersSchemaObject[a].spec.optional === true) return 1;
    return -1;
  });
  const orderedValuationParameters = [...prioritizedParameters, ...sortedRemainingParameters];

  //--------------------------------------------------------------------------------
  // synchronise this component's form with the parent component's form state
  //--------------------------------------------------------------------------------

  function syncParentForm() {
    // check if all validations are passed and if so, set component status to true
    if (isDirty && isValid) {
      // console.log('isDirty and isValid both true');
      const input = getValues();
      setUserInput({ ...userInput, ...input });
      updateWorkflowStatus(index, true);
      // reset isDirty status so that we know if the user touched the form again
      reset({ ...userInput, ...input }, { keepIsValid: true });
    }
    // check if the user invalidated the form and if so, remove the next step
    if (isDirty && !isValid) {
      const input = getValues();
      // CAVEAT: this approach means that the previously entered data is still potentially within the form
      setUserInput({ ...userInput, ...input });
      updateWorkflowStatus(index, false);
      // reset isDirty status so that we know if the user touched the form again
      reset({ ...userInput, ...input }, { keepErrors: true });
    }
  }

  useEffect(() => {
    // if the form has tags.nextValuationDate, display a dialog asking the user to be sure they provided all the info
    if (isDirty && isValid && getValues('tags.nextValuationDate') && !messageToShowBeforeNext) {
      syncParentForm();
      setMessageToShowBeforeNext('aboutToReceiveRealEstateValuation');
    } else syncParentForm();
  }, [formState]);

  //--------------------------------------------------------------------------------
  // subscribe to signal from parent that the user has clicked the "next" button
  // (and then trigger all validations to show errors)
  //--------------------------------------------------------------------------------

  useEffect(() => {
    if (signalNext) {
      trigger();
      setSignalNext(false);
    }
  }, [signalNext]);

  //--------------------------------------------------------------------------------
  // get valuationSlots from Cognito on initialisation
  //--------------------------------------------------------------------------------

  useEffect(() => {
    getAuthenticatedUser({ forceRefresh: true })
      .then((user) => {
        const result = JSON.parse(user.attributes['custom:valuation_slots'] || '[]');
        // console.log('result', result);
        setValuationSlots(result);
      })
      .catch((err) => console.error(err));
  }, []);

  //--------------------------------------------------------------------------------
  // when accounts / valuationSlots update,
  // decide if to show the automatic update switch
  //--------------------------------------------------------------------------------

  useEffect(() => {
    if (accountsWithValuationSlots.length < valuationSlots.length) {
      setValue('tags.nextValuationDate', getNextAvailableValuationDate(accountsWithValuationSlots, valuationSlots));
      setDisplayUpdateValueSwitch(true);
    } else setDisplayUpdateValueSwitch(false);
  }, [accounts, valuationSlots]);

  const type = watch('valuationParameters.type');

  //--------------------------------------------------------------------------------
  // handle subtype -- when type changes, reset subtype
  //--------------------------------------------------------------------------------

  useEffect(() => {
    // console.log('useEffect type changed');
    if (getValues('valuationParameters.type') === 'building') {
      setSubtypeList(Object.entries(t('app:schema.realEstate.account.parameters.subtype.building', { returnObjects: true })).map(([key, value]) => ({ id: key, name: value })));
    }
    if (getValues('valuationParameters.type') === 'apartment') {
      setSubtypeList(Object.entries(t('app:schema.realEstate.account.parameters.subtype.apartment', { returnObjects: true })).map(([key, value]) => ({ id: key, name: value })));
    }
  }, [type]);

  function handleNextValuationDateChange(newFieldValue) {
    // newFieldValue is the new boolean field value
    // when switch is flipped and the argument is TRUE, we need to set the nextValuationDate to the next available date
    if (newFieldValue) {
      setValue('tags.nextValuationDate', getNextAvailableValuationDate(accountsWithValuationSlots, valuationSlots));
    } else {
      setValue('tags.nextValuationDate', undefined);
    }
  }

  //--------------------------------------------------------------------------------
  // render the component
  //--------------------------------------------------------------------------------

  return (
    <div className="space-y-6 md:space-y-0 md:grid md:grid-cols-4 md:gap-6">
      <div className="md:col-span-1">
        <h3 className="text-xl md:text-2xl font-bold leading-6 text-gray-900">{t('R1.accountInfo')}</h3>
        <p className="mt-4 text-sm text-gray-500">{t('R1.provideInfo')}</p>
        <p className="mt-1 text-sm text-gray-500">{t('R1.oneAccount')}</p>
        <p className="mt-8 text-sm text-gray-500 font-bold">{t('R1.whyDoWeAsk')}</p>
        <p className="mt-2 text-sm text-gray-500">{t('R1.whyDoWeAskAnswer')}</p>
        <p className="mt-8 text-sm text-gray-500 font-bold">{t('R1.doIHaveToFillThemAllOut')}</p>
        <p className="mt-2 text-sm text-gray-500">{t('R1.doIHaveToFillThemAllOutAnswer')}</p>
      </div>

      <form className="md:col-span-3 ">
        <div className="divide-y divide-gray-200">
          <div className="py-3 lg:pb-4 grid xs:grid-cols-2 lg:grid-cols-3 gap-4 xs:gap-6 lg:gap-8">
            <InputField id="name" type="text" autoComplete="off" optional={false} register={register} errors={errors} validationRules={{ required: { value: true, message: t('R1.name.error') } }} />
            <div className="hidden md:col-span-2" />
            <InputField id="date" type="date" autoComplete="off" register={register} errors={errors} />
            <InputField
              id="originalPrice"
              type="text"
              autoComplete="off"
              register={register}
              errors={errors}
              validationRules={{
                number: { value: true, message: t('R1.originalPrice.error') },
              }}
            />
            <div>
              <div className="flex space-x-1">
                <label htmlFor="currency" className="block text-sm font-medium text-gray-700">
                  {t('R1.currency.label')}
                </label>
                <ToolTip info={t('R1.currency.tooltip')} />
              </div>
              <select
                id="currency"
                name="currency"
                onBlur={(e) => {
                  setUserInput({ ...userInput, ...getValues() });
                }}
                {...register('currency')}
                className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-brandBlue-400 focus:border-brandBlue-400 sm:text-sm rounded-md"
                defaultValue="EUR"
              >
                {currencyCodes.map((curr) => (
                  <option key={curr} value={curr}>
                    {curr}
                  </option>
                ))}
              </select>
            </div>
            {displayUpdateValueSwitch ? (
              <SwitchComponent
                onChange={handleNextValuationDateChange}
                onBlur={(e) => {
                  setUserInput({ ...userInput, ...getValues() });
                }}
                label={t('R1.automaticUpdate.label')}
                tooltip={t('R1.automaticUpdate.tooltip')}
                optional={false}
                value={watch('tags.nextValuationDate') !== undefined}
              />
            ) : (
              <div className="flex items-center space-x-2">
                <InformationCircleIcon className="h-5 w-5 text-brandBlue-400" aria-hidden="true" />
                <span className="text-sm font-medium text-gray-500">{t('R1.automaticUpdate.disabled')}</span>
              </div>
            )}
          </div>

          {/* VALUATION PARAMETERS */}

          <div className="py-3 lg:py-8 grid xs:grid-cols-2 lg:grid-cols-3 gap-4 xs:gap-6 lg:gap-8">
            {orderedValuationParameters.map((param) => {
              const schemaDefinition = valuationParametersSchemaObject[param];
              const isStringOrNumber = ['number', 'string'].includes(schemaDefinition.type);
              const hasOneOf = schemaDefinition._whitelist.size > 0 || param === 'subtype';
              const isOptional = schemaDefinition.spec.optional;

              if (['zip', 'city', 'district'].includes(param)) {
                const fieldActive = locationComboboxEnabled ? true : isCountrySelected;
                const locationValidationRules = !isOptional
                  ? {
                    validate: (value) => {
                      if (!fieldActive) return true;
                      return value ? true : tp(`${param}.error`);
                    },
                  }
                  : undefined;

                if (locationComboboxEnabled) {
                  const list = locationComboboxOptions[param] || [];
                  return (
                    <LocationCombobox
                      key={param}
                      id={`valuationParameters.${param}`}
                      label={tp(`${param}.label`)}
                      toolTip={tp(`${param}.tooltip`)}
                      placeholder={tp(`${param}.placeholder`)}
                      optional={isOptional}
                      control={control}
                      errors={errors}
                      options={list}
                      validationRules={locationValidationRules}
                      disabled={!isCountrySelected}
                    />
                  );
                }

                return (
                  <InputField
                    key={param}
                    id={`valuationParameters.${param}`}
                    type={schemaDefinition.type}
                    label={tp(`${param}.label`)}
                    placeholder={tp(`${param}.placeholder`)}
                    toolTip={tp(`${param}.tooltip`)}
                    register={register}
                    errors={errors}
                    optional={isOptional}
                    validationRules={locationValidationRules}
                    disabled={!isCountrySelected}
                  />
                );
              }

              if (isStringOrNumber && !hasOneOf) {
                const validationProps = isOptional ? {} : { validationRules: { required: { value: true, message: tp(`${param}.error`) } } };

                return (
                  <InputField
                    key={param}
                    id={`valuationParameters.${param}`}
                    type={schemaDefinition.type}
                    label={tp(`${param}.label`)}
                    placeholder={tp(`${param}.placeholder`)}
                    toolTip={tp(`${param}.tooltip`)}
                    register={register}
                    errors={errors}
                    optional={isOptional}
                    {...validationProps}
                  />
                );
              }

              if (isStringOrNumber && hasOneOf) {
                let list = [];
                if (param === 'energyClass') {
                  list = [...schemaDefinition._whitelist].map((x) => ({ id: x, name: x }));
                }
                if (param === 'countryCode') {
                  list = countryCodes.map((x) => ({ id: x, name: t([`countryNames.${getCountryName(x)}`, getCountryName(x)]) }));
                }
                if (param === 'subtype') {
                  list = subtypeList;
                }
                return (
                  <Dropdown
                    key={param}
                    id={`valuationParameters.${param}`}
                    list={list}
                    type={schemaDefinition.type}
                    label={tp(`${param}.label`)}
                    placeholder={tp(`${param}.placeholder`)}
                    toolTip={tp(`${param}.tooltip`)}
                    register={register}
                    errors={errors}
                    control={control}
                    optional={isOptional}
                  />
                );
              }

              if (schemaDefinition.type === 'boolean') {
                return (
                  <Controller
                    key={param}
                    name={`valuationParameters.${param}`}
                    control={control}
                    render={({ field: { onChange, onBlur, value, ref } }) => (
                      <SwitchComponent
                        id={`valuationParameters.${param}`}
                        onChange={onChange}
                        onBlur={onBlur}
                        value={value}
                        inputRef={ref}
                        label={tp(`${param}.label`)}
                        toolTip={tp(`${param}.tooltip`)}
                        optional={isOptional}
                      />
                    )}
                  />
                );
              }
              return true;
            })}
          </div>
        </div>
      </form>
    </div>
  );
}

RealEstateAccountData.propTypes = {
  index: PropTypes.number.isRequired,
  updateWorkflowStatus: PropTypes.func.isRequired,
  userInput: PropTypes.object,
  setUserInput: PropTypes.func,
  signalNext: PropTypes.bool,
  setSignalNext: PropTypes.func,
  messageToShowBeforeNext: PropTypes.string,
  setMessageToShowBeforeNext: PropTypes.func,
};
RealEstateAccountData.defaultProps = {
  userInput: {},
  setUserInput: {},
  signalNext: undefined,
  setSignalNext: () => {},
  messageToShowBeforeNext: '',
  setMessageToShowBeforeNext: () => {},
};

export default RealEstateAccountData;
